import React, { useRef } from 'react'
import Button from '../../Pages/LoginPage/Button';
import FloatingAuthInput from 'NewComponents/FormComponents/FloatingAuthInput/FloatingAuthInput';

const LoginForm = ({ handleLogin, handleEnter, onHandleChange,
  loginObj, validationModel, loading, forgotPassword, error }) => {

  const emailRef = useRef(null)
  const passwordRef = useRef(null)

 
  return (
    <div className="space-y-6">
      <FloatingAuthInput
        id="email"
        label="Email"
        type="email"
        placeholder=""
        required
        onKeyPress={handleEnter}
        name="email"
        onChange={onHandleChange}
        value={loginObj.email}
        ref={emailRef}
        autoFocus

      />
      {validationModel.emailError}

      <FloatingAuthInput
        id="password"
        label="Password"
        type="password"
        placeholder=""
        required
        onKeyPress={handleEnter}
        name="password"
        onChange={onHandleChange}
        value={loginObj.password}
        ref={passwordRef}
      />
      {validationModel.passwordError}
      {error ? <p className='max-w-sm text-red-500 '>{error}</p> : ""}

      <div className="flex items-center justify-end">
        {/* <label className="flex items-center text-sm text-gray-600 cursor-pointer group">
          <input
            type="checkbox"
            name="rememberMe"
            // checked={formData.rememberMe}
            // onChange={handleInputChange}
            className="w-4 h-4 mr-2 border-gray-300 rounded text-primary focus:ring-primary"
          />
          <span className="group-hover:text-primary">Remember me</span>
        </label> */}

        <button
          onClick={forgotPassword}
          type="button"
          className="text-sm font-medium text-right transition-colors text-primary hover:text-primary"
        >
          Forgot password?
        </button>
      </div>

      <Button loading={loading} onClick={handleLogin} variant="primary" fullWidth>
        Sign In
      </Button>

      <p className="mt-6 text-sm text-center text-gray-500">
        By logging in, you agree to our{' '}
        <a href="https://www.gettrucare.com/terms-of-use" target="_blank" rel="noopener noreferrer" className="font-medium text-primary hover:text-primary">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href="https://www.gettrucare.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="font-medium text-primary hover:text-primary">
          Privacy Policy
        </a>
      </p>
    </div>
  )
}

export default LoginForm